import { DRAFT_SHOOP } from './actionsTypes';

export const draftShoops = (draftShoops) => {
  return {
    type: DRAFT_SHOOP,
    draftShoops: draftShoops,
    name: "Draft"
  };
};
